import React from 'react';
import DotsLoading from '../../dotsLoading';

interface CustomButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  isLoading?: boolean;
}
const CustomButton = ({title, isLoading, ...props}: CustomButtonProps) => {
  return (
    <button {...props}>
      {isLoading ? <DotsLoading /> : title ? title : props.children}
    </button>
  );
};

export default CustomButton;
